import React from 'react';
import './MobileTicker.css';

function MobileTicker() {
  return (
    <div className="mobile-ticker" aria-hidden="true">
      <div className="ticker-track">
        {[...Array(2)].map((_, index) => (
          <React.Fragment key={index}>
            <span>342 Exhibitors</span>
            <span>45 Countries</span>
            <span>Cairo 2026</span>
            <span>Textile Machinery</span>
            <span>4 Event Days</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default MobileTicker;
